import _ from 'lodash';

export default function (data) {

	let	compiled = _.template(
		'<% if(gallery && defaultImage) { %>' +
			'<div class="gallery gallery--large">' +
				'<div class="gallery__viewport">' +
					'<img src="<%- defaultImage %>"/>' +
				'</div>' +
				'<div class="gallery__thumbnails" style="display: none">' +
					'<a class="gallery__thumbnails__prev <%- galleryPaginate %>"></a>' +
					'<div class="gallery__thumbnails__images">' +
					'<% for(var k in gallery){ %> <img data-viewport="<%- gallery[k].image %>" src="<%- gallery[k].thumbnail %>"/> <% } %>' +
					'</div>' +
					'<a class="gallery__thumbnails__next <%- galleryPaginate %>"></a>' +
				'</div>' +
			'</div>' +
		'<% } %>' +
		'<header class="mt3 clearfix">' +
			'<div class="flex flex-row justify-between mb1">'+
				'<div class="flex-column flex-grow">'+
					'<ul>'+
						'<li class="f5 md_f4 lh3 fw700 black hover-underline"><a class="black" href="<%= permalink %>"><%= title %></a></li>'+
						'<li class="f9 md_f8 lh4 fw600 dark-grey"><%= types %></li>'+
						'<% if(move_in) { %><li class="f8 lh3 fw600 dark-grey">Move-In <%= move_in %></li><% } %>'+										
						'<li class="f9 md_f8 lh4 fw600 grey"><% let i = 0; locations.forEach(function(location){ %> <%- location %> <% i = i+1; if(i !== locations.length ){ %> / <% } }) %>'+
					'</ul>'+
				'</div>'+
				'<div class="flex-column xmn30p">'+
					'<ul class="align-right">'+
						'<li class="f5 md_f3 lh3 sans fw800 black">$<%= price %></li>'+
						'<li class="dark-grey f9 md_f8 lh3 fw600"><%= beds %> / <%= baths %></li>'+
					'</ul>'+
				'</div>'+
			'</div>' +
			'<nav>' +
				'<ul class="left mb3 md_right md_mb0">' +
					'<li class="inline-block left">' +
						'<a href="#" data-title="<%= title %>" data-permalink="<%= permalink %>" class="button button--share">Share</a>' +
					'</li>' +
					'<li class="inline-block left ml1">' +
						'<a href="#" data-title="<%= title %>" data-permalink="<%= permalink %>" class="button button--contact" >Contact</a>' +
					'</li>' +
				'</ul>' +
			'</nav>' +
		'</header>' +
		'<div class="collapsible mb3">'+
			'<h4 class="f5 md_f4 alt-heading dark-grey legend">Description</h4>'+
			'<p><%= content %></p>' +
			'<div class="collapsible__nav">'+
				'<a class="collapsible__nav__toggle">Show More</a>'+
			'</div>'+
		'</div>'+
		'<div>'+
			'<h4 class="f5 md_f4 alt-heading dark-grey legend">Features</h4>'+
			'<ul class="flex flex-wrap">'+
				'<% amenities.forEach(function(amenity){ %><li class="x100p md_x50p f8 lh3"><%- amenity %></li> <% }) %>'+
			'</ul>'+
		'</div>'+
	'</div>'
	);

	let types = '';

	if ( data.types ) {
		let i = 0;
		data.types.forEach( (value) =>{
			i++;
			types += value;
			if ( data.types.length !== i ) types += ' / ';
		});
	}

	if (!data.gallery) data.gallery = [];

	let context = {
		id: data.id,
		title: data.title,
		content: data.content,
		price: data.price,
		types: types ? types : ' ',
		locations: data.location,
		beds: (data.beds !== '1') ? data.beds + ' Beds' : '1 Bed',
		baths: (data.baths !== '1') ? data.baths + ' Baths' : '1 Bath',
		amenities: data.amenities,
		gallery: data.gallery,
		galleryPaginate: (data.gallery.length > 5) ? 'is-active' : 'is-disabled-' + data.gallery.length,
		permalink: data.permalink,
		move_in: data.move_in
	}

	if ( data.gallery ) {
		for ( let k in data.gallery ) {
			context.defaultImage = data.gallery[k]['image'];
			break;
		}
	}

	context.defaultImage = context.defaultImage ? context.defaultImage : false;


	return compiled(context);

}
